// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10c4y","inner":"Footer_inner__37q9h","nextIcon":"Footer_nextIcon__27ieM","innerLeft":"Footer_innerLeft__24U5w"};